export enum RADIUS_FILTERS {
  UNLIMITED_RADIUS = 'all',
  DEFAULT_RADIUS_IN_KILOMETERS = 100,
  RADIUS_IN_METERS_FOR_NO_OFFERS = 1,
}
